export const mutationsCustomFields = {
    setHasUnfilledCustomFields(state, payload) {
        state.hasUnfilledCustomFields = payload
    },
}
